/**
 * @file Settles a payment with another or a new payment through `payment/:id/settle` and confirms it in a snackbar.
 * A refusal the payment-settle route is known to send opens the refusal dialog with that path's texts.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  financial_operations_were_blocked: { titleKey: "refusal-title-settle", bodyKey: "refusal-body-financial-processing-busy" },
  forbidden_update_removed_payment: { titleKey: "refusal-title-settle", bodyKey: "refusal-body-settle-removed-payment" },
  cannot_settle_payment_linked_to_direct_charge: { titleKey: "refusal-title-settle", bodyKey: "refusal-body-settle-payment-direct-charge" },
  cannot_settle_payment_with_equal_types: { titleKey: "refusal-title-settle", bodyKey: "refusal-body-settle-equal-payment-types" },
  savings_payment_was_not_removed: { titleKey: "refusal-title-settle", bodyKey: "refusal-body-settle-special-payment" }
};

export default function* paymentSettle(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_SETTLE_REQUEST
    })

    let payload: any = {};

    if (!!action.payload?.paymentId) {
      payload.paymentId =  action.payload?.paymentId;
    }

    if (!!action.payload?.newPayment) {
      payload.newPayment = {...action.payload?.newPayment};
    }

    const res = yield call(Http.post, `payment/${action.payload?.id}/settle`, {
      ...payload
    });

    const charge: ChargeInterface = ChargeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_PAYMENT_SETTLE_SUCCESS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-payment-settled-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, charge);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_PAYMENT_SETTLE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentSettle() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_SETTLE_START, paymentSettle);
}
